/**
 * JS for the Zapier chatbot.
 */
export function ZapierChatbot() {
  const defaultChatbotEmbed = `
    <zapier-interfaces-chatbot-embed
      is-popup="false"
      chatbot-id="clsfnizig0006694p3rd4kzle"
      height="600px"
      width="400px"
    ></zapier-interfaces-chatbot-embed>
  `;

  /**
   * Initializes the Zapier chatbot by adding the necessary listeners.
   */
  function init() {
    listenForChatToggleClick();
    listenForChatbotResize();
    initializeEmbeddedChat();
  }

  /**
   * Listens for the chat toggle button click and toggles the chat popup.
   */
  function listenForChatToggleClick() {
    $('#zapier-chat-toggle').click(() => {
      $('#zapier-chat-popup').toggle();
      $('#zapier-chat-greeting').hide();
    });
  }

  /**
   * Observes the target element for resize events and notifies the parent window when the size changes.
   */
  function listenForChatbotResize() {
    const resizeObserver = new ResizeObserver((entries) => {
      for (let entry of entries) {
        window.parent.postMessage(
          JSON.stringify({
            height: entry.target.clientHeight,
            width: entry.target.clientWidth,
            event: 'zapier-chatbot-resize',
          })
        );
      }
    });

    resizeObserver.observe($('#zapier-chatbot-widget')[0]);
  }

  /**
   * Initializes the embedded chat by loading the chat window.
   *
   * If `window.parent.zapierEmbeddedChat` is not available after 3 attempts at 3-second intervals, the default chatbot
   * embed will be loaded.
   */
  function initializeEmbeddedChat() {
    if (window.parent.zapierEmbeddedChat) {
      loadChat(window.parent.zapierEmbeddedChat, null);

      return;
    }

    let attempts = 0;
    const intervalId = setInterval(() => {
      if (window.parent.zapierEmbeddedChat || attempts >= 3) {
        loadChat(window.parent.zapierEmbeddedChat || defaultChatbotEmbed, intervalId);
      }
      attempts++;
    }, 3000);
  }

  /**
   * Loads chat HTML code into a specified element and shows chat elements.
   *
   * @param {string} htmlCode the HTML code to be loaded into the chat element
   * @param {number|null} intervalId the ID of the interval timer to be cleared
   */
  function loadChat(htmlCode, intervalId) {
    clearInterval(intervalId);
    $('#zapier-embedded-chat').html(htmlCode);
    $('#zapier-chat-toggle').show();
    $('#zapier-chat-greeting').show();
  }

  return {
    init,
  };
}

$(document).ready(function () {
  const zapierChatbot = new ZapierChatbot();
  zapierChatbot.init();
});
